export const SEARCH_SECTION_ITEMS =
  'app/conversion/sectionDetails/SEARCH_SECTION_ITEMS';

export const CLEAN_SEARCH = 'app/conversion/sectionDetails/CLEAN_SEARCH';

export const FILTER_SECTION_ITEMS =
  'app/conversion/sectionDetails/FILTER_SECTION_ITEMS';
